import { MapTo } from "@adobe/aem-react-editable-components";
import { AuthoringUtils } from "@adobe/aem-spa-page-model-manager";
import { LoyaltyReferralCodeExtended } from "@jti/ui";
import { withAemAuthoring } from "../../app-related/withAemAuthoring";
export const LoyaltyReferralCodeExtendedEditConfig = {
    emptyLabel: "The MGM Account Dashboard is hidden, or some configuration properties are missing. ",
    isEmpty: (props) => {
        if (props.isHidden === true) {
            return true;
        }
        return (!props.discountImageDesktop ||
            !props.discountImageTablet ||
            !props.discountImageMobile ||
            !props.successHeading ||
            !props.successLabel ||
            !props.successBtnLabel ||
            !props.successLink ||
            !props.heading ||
            !props.label ||
            !props.list ||
            !props.legalText ||
            !props.discountHeading ||
            !props.discountLabel ||
            !props.discountSubText ||
            !props.validationRequiredMessage ||
            !props.verifyErrorMessage ||
            !props.inputLabel ||
            !props.inputPlaceholder ||
            !props.inputHelperText ||
            !props.btnText);
    },
    getProps: (props) => {
        return {
            discountImageDesktop: props.discountImageDesktop,
            discountImageTablet: props.discountImageTablet,
            discountImageMobile: props.discountImageMobile,
            successHeading: props.successHeading,
            successLabel: props.successLabel,
            successBtnLabel: props.successBtnLabel,
            successLink: props.successLink,
            heading: props.heading,
            label: props.label,
            list: props.list,
            legalText: props.legalText,
            discountHeading: props.discountHeading,
            discountLabel: props.discountLabel,
            discountSubText: props.discountSubText,
            validationRequiredMessage: props.validationRequiredMessage,
            verifyErrorMessage: props.verifyErrorMessage,
            inputLabel: props.inputLabel,
            inputPlaceholder: props.inputPlaceholder,
            inputHelperText: props.inputHelperText,
            btnText: props.btnText,
            isInEditor: AuthoringUtils.isInEditor(),
            isHidden: props.isHidden,
        };
    },
};
export default MapTo("loyalty/components/mgmAccountDashboard")(withAemAuthoring(LoyaltyReferralCodeExtended, LoyaltyReferralCodeExtendedEditConfig));
